export const getShoppingCartPrices = (shoppingCartProducts = []) => {
  const shoppingCartPrices = {
    total: 0,
    subtotal: 0,
    quantity: 0,
    discount: 0,
  };

  shoppingCartProducts.forEach(({ msrp, price, quantity = 0 }) => {
    shoppingCartPrices.total += price * quantity;
    shoppingCartPrices.subtotal += price * quantity;
    shoppingCartPrices.discount += (msrp - price) * quantity;
    shoppingCartPrices.quantity += quantity;
  });

  return shoppingCartPrices;
};

export const priceFormat = (x) => x?.toLocaleString('es-MX');
